/* ATB retired product block (2026-10-17) — snippets/atb-retired.liquid
   - "Notify me" → the existing back-in-stock endpoint on app.adamstoybox.com
   - "Ask Adam" → opens the chat widget and pre-fills "Something like <title>"
   - Arrows for the "Also worth a look" row when the cards overflow
   - Tracker event `retired_click` {from, to, slot} on clicks (the tracker sends it from the document event).
   The match card links to the product ("Shop it"); there is no add to cart here (owner, 2026-10-17). */
(function () {
  'use strict';

  var BIS_URL = 'https://app.adamstoybox.com/api/back-in-stock/subscribe';

  function track(payload) {
    try {
      var T = window.AdamsToyBoxTracker;
      if (T) {
        if (typeof T.track === 'function') T.track('retired_click', payload);
        else if (typeof T.trackEvent === 'function') T.trackEvent('retired_click', payload);
      }
      document.dispatchEvent(new CustomEvent('atb:retired_click', { detail: payload }));
    } catch (e) {
      /* tracking never breaks the page */
    }
  }

  function notify(form) {
    var block = form.closest('[data-atb-retired]');
    var msg = block.querySelector('.atb-ret-notify__msg');
    var input = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button');
    var email = (input.value || '').trim();
    if (!email || email.indexOf('@') < 1) {
      msg.textContent = 'Enter a valid email.';
      input.focus();
      return;
    }
    var variantTitle = block.getAttribute('data-variant-title');
    var image = block.getAttribute('data-image');
    var payload = {
      email: email,
      productId: block.getAttribute('data-product-id'),
      variantId: block.getAttribute('data-variant-id'),
      productTitle: block.getAttribute('data-title'),
      variantTitle: variantTitle ? variantTitle : null,
      productImage: image ? (image.indexOf('//') === 0 ? 'https:' + image : image) : null,
      productHandle: block.getAttribute('data-from')
    };
    btn.disabled = true;
    msg.textContent = '';
    fetch(BIS_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || !data || !data.success) throw new Error((data && data.error) || 'failed');
          return data;
        });
      })
      .then(function (data) {
        form.classList.add('is-done');
        msg.textContent = data.alreadySubscribed ? "You're already on the list." : "You're on the list. We'll email you if it comes back.";
      })
      .catch(function () {
        msg.textContent = 'Something went wrong. Try again in a moment.';
      })
      .then(function () {
        btn.disabled = false;
      });
  }

  function askAdam(block) {
    var A = window.AskAdam;
    if (!A || typeof A.open !== 'function') return;
    A.open();
    var title = block.getAttribute('data-title') || '';
    var tries = 0;
    (function fill() {
      var input = document.getElementById('ask-adam-lite-input');
      if (!input) {
        if (++tries < 10) setTimeout(fill, 100);
        return;
      }
      if (!input.value) {
        input.value = 'Something like ' + title;
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
      try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
    })();
  }

  document.addEventListener('click', function (e) {
    var block = e.target.closest && e.target.closest('[data-atb-retired]');
    if (!block) return;
    var from = block.getAttribute('data-from');

    var link = e.target.closest('[data-atb-ret-to]');
    if (link) {
      track({ from: from, to: link.getAttribute('data-atb-ret-to'), slot: link.getAttribute('data-atb-ret-slot') });
      return;
    }
    var arrow = e.target.closest('[data-atb-ret-scroll]');
    if (arrow) {
      var row = block.querySelector('.atb-ret-alts');
      if (row) row.scrollBy({ left: Number(arrow.getAttribute('data-atb-ret-scroll')) * row.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }
    if (e.target.closest('[data-atb-ret-adam]')) {
      e.preventDefault();
      askAdam(block);
    }
  });

  // Show the arrows only when the cards overflow, and dim the one that can't go further.
  function syncArrows(row) {
    var arrows = row.parentNode.querySelector('.atb-ret-arrows');
    if (!arrows) return;
    var max = row.scrollWidth - row.clientWidth;
    arrows.hidden = max < 4;
    var b = arrows.querySelectorAll('button');
    b[0].disabled = row.scrollLeft < 4;
    b[1].disabled = row.scrollLeft > max - 4;
  }
  function initArrows() {
    document.querySelectorAll('[data-atb-retired] .atb-ret-alts').forEach(function (row) {
      if (row._atbArrows) return;
      row._atbArrows = true;
      syncArrows(row);
      row.addEventListener('scroll', function () { syncArrows(row); }, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(function () { syncArrows(row); }).observe(row);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initArrows);
  else initArrows();

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-atb-ret-notify]');
    if (!form) return;
    e.preventDefault();
    notify(form);
  });
})();
